var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnLoginbtn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "30px",
    viewBox: "0 0 22 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    shapeRendering: "optimizeSpeed",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Page 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "path-2",
    points: "14.242 11.1902 14.242 22.3806 0 22.3806 0 11.1902 0 -0.0002 14.242 -0.0002 14.242 11.1902"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bioscann-Home",
    transform: "translate(-1151.000000, -24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nav-Bar"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    filter: "url(#filter-1)",
    transform: "translate(1138.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(17.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.647,16.2768 C8.366,16.2768 8.138,16.5048 8.138,16.7858 C8.138,17.0668 8.366,17.2938 8.647,17.2938 C8.928,17.2938 9.156,17.0668 9.156,16.7858 C9.156,16.5048 8.928,16.2768 8.647,16.2768 L8.647,16.2768 Z M1.017,2.0348 L13.225,2.0348 L13.225,1.0178 L1.017,1.0178 L1.017,2.0348 Z M11.19,4.1788 C10.602,4.3378 10.065,4.5788 9.461,4.8608 C8.71,5.2118 7.859,5.6088 6.589,6.0038 C5.336,6.3938 4.066,6.0518 3.052,5.5678 L3.052,3.0518 L11.19,3.0518 L11.19,4.1788 Z M11.19,17.2938 C11.19,19.5418 9.368,21.3638 7.121,21.3638 C4.874,21.3638 3.052,19.5418 3.052,17.2938 L3.052,6.6148 C3.773,6.9078 4.585,7.1218 5.444,7.1218 C5.924,7.1218 6.416,7.0568 6.911,6.9028 C8.25,6.4878 9.174,6.0558 9.916,5.7088 C10.392,5.4868 10.791,5.3038 11.19,5.1688 L11.19,17.2938 Z M13.225,-0.0002 L1.017,-0.0002 C0.456,-0.0002 0,0.4558 0,1.0178 L0,2.0348 C0,2.5968 0.456,3.0518 1.017,3.0518 L2.035,3.0518 L2.035,17.2938 C2.035,20.1038 4.312,22.3808 7.121,22.3808 C9.93,22.3808 12.208,20.1038 12.208,17.2938 L12.208,3.0518 L13.225,3.0518 C13.787,3.0518 14.242,2.5968 14.242,2.0348 L14.242,1.0178 C14.242,0.4558 13.787,-0.0002 13.225,-0.0002 L13.225,-0.0002 Z M9.156,8.1388 C8.594,8.1388 8.138,8.5938 8.138,9.1558 C8.138,9.7178 8.594,10.1728 9.156,10.1728 C9.717,10.1728 10.173,9.7178 10.173,9.1558 C10.173,8.5938 9.717,8.1388 9.156,8.1388 L9.156,8.1388 Z M6.104,11.1908 C6.104,10.6288 5.648,10.1728 5.086,10.1728 C4.525,10.1728 4.069,10.6288 4.069,11.1908 C4.069,11.7528 4.525,12.2078 5.086,12.2078 C5.648,12.2078 6.104,11.7528 6.104,11.1908 L6.104,11.1908 Z M5.595,18.3118 C5.314,18.3118 5.086,18.5388 5.086,18.8198 C5.086,19.1008 5.314,19.3288 5.595,19.3288 C5.876,19.3288 6.104,19.1008 6.104,18.8198 C6.104,18.5388 5.876,18.3118 5.595,18.3118 L5.595,18.3118 Z M6.612,14.2418 C6.332,14.2418 6.104,14.4698 6.104,14.7508 C6.104,15.0318 6.332,15.2598 6.612,15.2598 C6.893,15.2598 7.121,15.0318 7.121,14.7508 C7.121,14.4698 6.893,14.2418 6.612,14.2418 L6.612,14.2418 Z",
    id: "Fill-1",
    fill: "#FFFFFF",
    mask: "url(#mask-3)"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnLoginbtn);
export default __webpack_public_path__ + "static/media/icn_loginbtn.0f3c6474a90b0f4c59cb1ad600380070.svg";
export { ForwardRef as ReactComponent };